import FalconComponentCard from "components/common/FalconComponentCard";
import React, { useCallback, useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import UserPermissionListTable from "./components/UserPermissionListTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetAllDropDownData } from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";

const UserPermissionList = () => {
  const dispatch = useDispatch();
  const { systemPrivillageList } = useSelector((state) => state.empolyee);
  const navigate = useNavigate();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to first page when changing page size
  }, []);

  useEffect(() => {
    if (systemPrivillageList?.length === 0) {
      dispatch(GetAllDropDownData());
    }
  }, [systemPrivillageList]);

  return (
    <FalconComponentCard className="shadow-md" style={{ position: "relative" }}>
      <FalconComponentCard.Header
        className="d-flex  fixed-header py-2 justify-content-between align-items-center"
        sx={{
          position: "sticky !important",
          top: 68,
          zIndex: 1020,
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <Col xs="auto m-0">
          <h5 className="text-primary mb-0 fs-10">User Permissions</h5>
        </Col>
        <Col xs="auto" className="d-flex gap-2"></Col>
      </FalconComponentCard.Header>
      <FalconComponentCard.Body
        style={{
          marginTop: "40px", // Adjust this value based on header height
          overflowY: "auto",
          maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
        }}
      >
        <UserPermissionListTable
          data={systemPrivillageList}
          totalRows={totalRows}
          handlePageChange={handlePageChange}
          handlePerRowsChange={handlePerRowsChange}
          page={page}
          rowsPerPage={rowsPerPage}
        />
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
};

export default UserPermissionList;
